define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action",
	"csi/action/Submit",
	"csi/def/Action",
	"csi/def/Parameter",
	"csi/def/Request",
	"csi/def/ViewRef",
	"csi/heading/SelectController",
	"csi/locale",
	"csi/reflection",
	"csi/table/Widget",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,lang,_,csiAction,SubmitAction,Action,Parameter,Request,ViewRef,SelectController,locale,reflection,Widget,MessageDialog,xml) {

	return declare(Widget, {
		onViewToolbar: function(/*csi.view.Toolbar*/tb) {
			var dropDown = tb.getPlugin('Export');
			if (dropDown) {
				dropDown.set("label", _.escape(locale.resource("ExportImport")));

				var node = this.getViewNode();
				var cnlCompanyInfo = node.$URL;
				if (node.$Type != xml.TYPE_COMPANY_INFO)
					cnlCompanyInfo = xml.getUrlPath(cnlCompanyInfo, "Child:CompanyInfo");

				var	ctx = this.getContext();
				var	actionExportXML = lang.mixin(new Action(), {
					m_id: "ExportXML",
					m_onAction: "SiteAdmin.onActionExportUsers"
				});
				var	actionImportXML = lang.mixin(new SubmitAction(), {
					m_id: "ImportXML",
					m_postAction: function(ac) {
						if (ac.m_response.getReturnValue()) {
							new MessageDialog({
								buttons: [MessageDialog.BUTTON_OK],
								materialIcon: MessageDialog.ICON_WARNING,
								message: locale.resource("ImportUsersWarning"),
								title: locale.resource("WARNING")
							}).show();
						}
						
						ac.widget.postActionRefresh(this);
					},
					m_viewRef:  lang.mixin(new ViewRef(), {
						m_id: "ImportUsers",
						m_url: reflection.URL_SITE
					}),
					m_request: lang.mixin(new Request(), {
						m_module: "SiteAdmin",
						m_operation: "ImportUsers",
                        m_parameters: [
                        	lang.mixin(new Parameter(), {
	                            m_id: "URL",
	                            m_typeAttr: "ref",
	                            m_value: cnlCompanyInfo
	                        })
	                   ]
					})
				});
				actionExportXML.resolve(null, reflection.getClass(xml.TYPE_COMPANY_INFO));
				actionImportXML.resolve(null, reflection.getClass(xml.TYPE_COMPANY_INFO));

				tb.addPlugin(ctx, actionExportXML, null, null, dropDown.dropDown);
				tb.addPlugin(ctx, "|", null, null, dropDown.dropDown);
				tb.addPlugin(ctx, actionImportXML, null, null, dropDown.dropDown);
			}

			this.inherited(arguments);
		}
	});
});